/**
 * Created by jv on 08/09/2017.
 */
//js
const Shared = require("Sources/shared");
const LanguageManager = require("Sources/services/language-manager");
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();

//Styles
require("Styles/pages/index.scss");

$(function () {
  Shared.shouldSetUpCreditsDialog = false;
  Shared.init();

  LandingsPage.init();
});

let LandingsPage = {};

((LandingsPage) => {
  LandingsPage.init = function () {
    setUpEventListeners();
  };

  function setUpEventListeners() {

  }
})(LandingsPage);



// WEBPACK FOOTER //
// ./app/js/entries/index.js